import { render, staticRenderFns } from "./MoblieAdvantage.vue?vue&type=template&id=8521230e&scoped=true&"
import script from "./MoblieAdvantage.vue?vue&type=script&lang=js&"
export * from "./MoblieAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./MoblieAdvantage.vue?vue&type=style&index=0&id=8521230e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8521230e",
  null
  
)

export default component.exports